<template>
    <painel-component :items="itemsOne">
        <error-component :errors="errors" v-if="showError" :class="'mb-5'"/>

        <div class="aux my-4">
            <div class="avatar-form">
                <img v-if="me.photo" :src="imagePreview" alt="" class="avatar__image">
                <img v-else src="@/assets/avatar.png" alt="" class="avatar__image">
            </div>
            <p>{{ me.name }}</p>
        </div>

        <form autocomplete="off">
            <row-component>
                <col-component :class-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                    <label>Senha</label>
                    <input-component type="password" v-model="formDate.password"/>
                </col-component>

                <col-component :class-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                    <label>Confirmar Senha</label>
                    <input-component type="password" v-model="formDate.passwordconfirm"/>
                </col-component>
            </row-component>

            <row-component>
                <col-component :class-col="'col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12'">
                    <button-route class="w-100" :items="itemsTwo"/>
                </col-component>

                <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <button-submit :disabled="sendForm" @click="submit" class="w-100" name="Salvar" icon="save"/>
                </col-component>
            </row-component>
        </form>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/row/RowComponent";
import ColComponent from "@/components/row/ColComponent";
import InputComponent from "@/components/form/InputComponent";
import ErrorComponent from "@/components/alerts/ErrorComponent";
import ButtonRoute from "@/components/buttons/ButtonRoute";
import ButtonSubmit from "@/components/buttons/ButtonSubmit";
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "UserUpdatePassword",

    created() {
        this.$store.dispatch('changeNamePage', 'Usuário')
    },

    components: {
        ErrorComponent,
        ButtonSubmit,
        ButtonRoute,
        InputComponent,
        ColComponent,
        RowComponent,
        PainelComponent,
    },

    data() {
        return {
            itemsOne: {
                title: "Editar",
                icon: "edit"
            },

            itemsTwo: {
                route: "/",
                icon: "reply all",
                name: "Voltar",
            },

            formDate: {
                password: '',
                passwordconfirm: ''
            },

            imagePreview: "",

            errors: [],
            showError: false,
            sendForm: false,
        }
    },
    methods: {
        submit() {
            if (!this.sendForm) {
                this.sendForm = true;
                this.$store.dispatch('updateUserPassword', this.formDate)
                    .then(() => {
                        this.showError = false
                        this.sendForm = false
                        toast.success('Senha atualizada com sucesso', {timeout: 2000});
                    }).catch((r) => {
                    this.showError = true;
                    this.sendForm = false
                    this.errors = r.response.data.errors;
                    toast.error("Seu formulário contém erros verificar!", {timeout: 2000});
                })
            }
        },

        photoPreviewTimer() {
            this.imagePreview = this.me.photo
        }
    },

    computed: {
        me() {
            return this.$store.state.auth.me
        },
    },

    beforeMount() {
        setTimeout(() => this.photoPreviewTimer(), 1000);
    },
}
</script>